<ng-container *ngIf="filter">
  <div class="header-top">
    <!--
    Feeds CTA
   -->
    <span *ngIf="subscriptionToInsights && viewInsightPermission" [ui2Tooltip]="tooltipRefineFeed">
      <signals-refine-feed-cta
        [element]="element"
        [filter]="filter"
        [linkedSearchField]="linkedSearchField"
        [copyOverrides]="copyOverrides"
        [viewOnly]="viewOnly"
        (onLinkedSearchFieldCreated)="onLinkedSearchFieldCreated.emit($event)"
      ></signals-refine-feed-cta>
    </span>

    <!--
      We show search bar inplace of refine feed if user dont have subscription for insight
    -->
    <span *ngIf="!subscriptionToInsights || !viewInsightPermission" class="signal-search-container">
      <ng-container *ngTemplateOutlet="signalSearch"></ng-container>
    </span>

    <div class="button-icons">
      <!--
      Search
      We only show search icon if user has subscription for insight, otherwise we dont need search button since refined feed is replaced by search bar itself
     -->
      <ui2-button
        *ngIf="subscriptionToInsights && viewInsightPermission"
        [title]="'newsFeedWidget.header.iconsTooltips.search' | translate"
        [class.active]="toggleSearch"
        class="button-icon"
        (clicked)="onToggleSearch()"
      >
        <span class="icon icon2-x16-search"> </span
      ></ui2-button>

      <!--
      Filters
     -->

      <ui-menu-container class="filter" [trigger]="'click'" [placement]="'bottom-end'" [applyClass]="'blank-container'">
        <ng-template #buttonTemplate>
          <ui2-button [title]="'newsFeedWidget.header.iconsTooltips.filter' | translate" class="button-icon">
            <span class="icon icon2-x16-filter"> </span
          ></ui2-button>
        </ng-template>

        <div class="filter-items">
          <!--
            Filter by:
            Blocked, Pinned, Negative, Positive
         -->
          <div class="filter-item">
            <div class="filter-label label-sm-single">{{ 'newsFeedWidget.header.signalsFilter' | translate | titleCase }}</div>
            <signals-filter-dropdown
              [evaluationBasis]="evaluationBasis"
              [filterIdentifier]="filterIdentifier"
              [filter]="filter"
              [actions]="signalsFilterActions"
              (filterSelected)="signalsFilterSelection.emit($event)"
            ></signals-filter-dropdown>
          </div>

          <div class="filter-item">
            <!--
            Filter by:
            Type
          -->
            <div class="filter-label label-sm-single">{{ 'newsFeedWidget.header.typeFilter' | translate | titleCase }}</div>
            <!-- This is old header we are not using it anymore
             so this component as of now as it has been refactored. -->
            <!-- <signals-filter-type-dropdown
              [filterIdentifier]="filterIdentifier"
              [filter]="filter"
              [filterBy]="filterBy"
              [signalUris]="signalsUris"
              (onTypeChanged)="typeFilterSelection.emit($event)"
            ></signals-filter-type-dropdown> -->
          </div>

          <div class="filter-item">
            <!--
            Filter by:
            Source
          -->
            <div class="filter-label label-sm-single">{{ 'newsFeedWidget.header.sourceFilter' | translate | titleCase }}</div>
            <signals-filter-source
              #filterType
              [filterIdentifier]="filterIdentifier"
              [filter]="filter"
              [filterBy]="filterBy"
              [signalUris]="signalsUris"
              (onSourceChanged)="sourceFilterSelection.emit($event)"
            ></signals-filter-source>
          </div>

          <!--
              Temporary solution for presets
              while we have the design implemented
              https://itonics.atlassian.net/browse/CIN-538
          -->

          <div
            *ngIf="subscriptionToInsights && viewInsightPermission && !isFact"
            class="filter-item"
            [class.hidden]="!showSearchFieldSelector"
          >
            <div class="filter-label label-sm-single">
              {{ 'newsFeedWidget.header.presets' | translate | titleCase }}
            </div>
            <signals-search-field-selector-v2
              class="search-field-selector"
              [filter]="filter"
              [subscriptionToInsights]="subscriptionToInsights"
              [element]="element"
              [linkedSearchField]="linkedSearchField"
              [onlyShowExplicitSearchFields]="onlyShowExplicitSearchFields"
              (onSearchFieldSelected)="onSearchFieldSelected($event)"
              (ready)="searchFieldSelectorReady($event)"
            ></signals-search-field-selector-v2>
          </div>
        </div>
      </ui-menu-container>

      <!--
      Sorting
     -->
      <signals-sort-list
        [title]="'newsFeedWidget.header.iconsTooltips.sort' | translate"
        class="filter"
        (onSort)="sort.emit($event)"
      ></signals-sort-list>
    </div>
  </div>

  <!--
  Animated header bottom
  If use has subscription for insight, otherwise we hide the search bar because we will already have searchbar in place of refine feed button
 -->
  <div *ngIf="subscriptionToInsights && viewInsightPermission" [class.open]="toggleSearch" class="header-bottom">
    <ng-container *ngTemplateOutlet="signalSearch"> </ng-container>
  </div>
</ng-container>

<!--
  Use template for search bar because we have to use it in two different place on the basis of subscription to insight
  1) Inplace of refineFeed button if no subscription for insight
  2) Below the header with animation if use has subscription for insight
-->
<ng-template #signalSearch>
  <ui2-search-input
    [title]=""
    class="ui2-search-input"
    [focus]="focus"
    [(ngModel)]="searchQuery"
    [placeholder]="'newsFeedWidget.searchFeed' | translate"
    name="search-title"
    (ngModelChange)="search.emit(searchQuery)"
  >
  </ui2-search-input>
</ng-template>
